import type { PayloadAction } from "@reduxjs/toolkit";

import type { IGridMode } from "./models";

export const UPDATE = "gridMode/update";
export function updateGridMode(payload: IGridMode): PayloadAction<IGridMode> {
  localStorage.setItem("Verwimp.catalog.grid-mode", payload.gridMode);
  document
    .getElementById("white-instant-search-hits")
    ?.classList.toggle("grid");
  document
    .getElementById("white-instant-search-hits")
    ?.classList.toggle("list");
  return {
    type: UPDATE,
    payload,
  };
}
